import { redirectByRuleOrHomeOnMissing } from "~/helpers/redirectRule";

export async function loadQuestionOrRedirect(context, questionStore, route) {
  const question = await questionStore.loadQuestion(
    route.params.questionSeoName
  );
  if (!question) {
    await redirectByRuleOrHomeOnMissing({ ...context, route });
  }
  return question;
}
